/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ChatMessage } from 'walden-fast/types/chat';
import type { ChatSuggestion } from 'walden-fast/types/chat';

export interface ChatWindowSignature {
  // The arguments accepted by the component
  Args: {
    messages: ChatMessage[];
    isDisabled?: boolean;
    isLoading: boolean;
    onMessage: (message: string) => void;
    size?: 'full' | 'narrow';
    suggestions?: ChatSuggestion[];
  };
  // Any blocks yielded by the component
  Blocks: {
    header: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}

export default class ChatWindowComponent extends Component<ChatWindowSignature> {
  @tracked
  inputMessage: string = '';

  get showSuggestions(): boolean {
    return this.args.messages.length <= 1;
  }

  @action
  sendMessage(event: Event) {
    event.preventDefault();
    this.args.onMessage(this.inputMessage);
    this.inputMessage = '';
  }

  @action
  sendMessageFromSuggestion(message: string): void {
    this.args.onMessage(message);
    this.inputMessage = '';
  }

  @action
  setInputMessageFromSuggestion(message: string): void {
    this.inputMessage = message;
  }
}
